import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaPhone } from 'react-icons/fa';
import { COMPANY_PHONE_TEL, COMPANY_PHONE_DISPLAY } from '../constants';

const Header = ({ onContactClick, onBookClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { title: 'Services', path: '/services' },
    { title: 'About', path: '/about' },
    { title: 'Careers', path: '/careers' },
    { title: 'FAQ', path: '/faq' }
  ];

  const handleContactClick = (e) => {
    if (onContactClick) onContactClick(e);
    setIsMenuOpen(false);
  };
  
  const handleBookClick = () => {
    if (onBookClick) onBookClick();
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className="header">
        <div className="container">
          <div className="header-content">
            <Link to="/" className="logo">
              <img src="/logo192.png" alt="Sky Harbor Shuttle" />
            </Link>

            {/* Desktop Navigation */}
            <nav className="nav-desktop">
              {navItems.map((item) => (
                <Link key={item.path} to={item.path}>
                  {item.title}
                </Link>
              ))}
              <a href="#contact" onClick={handleContactClick}>Contact</a>
              <button 
                className="btn btn-icon" 
                onClick={() => window.location.href = `tel:${COMPANY_PHONE_TEL}`} 
                aria-label={`Call us at ${COMPANY_PHONE_DISPLAY.replace(/[()]/g, '').replace(/\s/g, '-')}`}
              >
                <FaPhone />
              </button>
              <button className="btn btn-primary" onClick={handleBookClick}>Request Quote</button>
            </nav>

            {/* Mobile Header Actions - Always visible */}
            <div className="mobile-header-actions">
              <button 
                className="btn btn-icon" 
                onClick={() => window.location.href = `tel:${COMPANY_PHONE_TEL}`} 
                aria-label={`Call us at ${COMPANY_PHONE_DISPLAY.replace(/[()]/g, '').replace(/\s/g, '-')}`}
              >
                <FaPhone />
              </button>
              <button className="btn btn-primary mobile-book-btn" onClick={handleBookClick}>Request Quote</button>
              
              {/* Mobile Menu Button */}
              <button 
                className="menu-toggle"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                aria-label="Toggle Menu"
              >
                <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}></span>
              </button>
            </div>

            {/* Mobile Navigation */}
            <AnimatePresence>
              {isMenuOpen && (
                <motion.nav 
                  className="nav-mobile"
                  initial={{ opacity: 0, x: '100%' }}
                  animate={{ opacity: 1, x: 0 }}
                  exit={{ opacity: 0, x: '100%' }}
                  transition={{ type: 'tween' }}
                >
                  {navItems.map((item) => (
                    <Link 
                      key={item.path} 
                      to={item.path}
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {item.title}
                    </Link>
                  ))}
                  <a href="#contact" onClick={handleContactClick}>Contact</a>
                </motion.nav>
              )}
            </AnimatePresence>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header; 